import React, { useEffect } from 'react'
import { Button } from '@material-ui/core';
import { useDispatch, useSelector } from 'react-redux';
import { AutorizacionesAccordionEfector } from '../../Ingreso/Accordions/AutorizacionesAccordionEfector';
import { AUTORIZACIONES_SOLICITUDES_ESTADOS, AUTORIZACIONES_TIPO_EFECTOR } from '../../../../utils/constants';
import { 
  getEfectorLaboratorio, 
  getPracticasSolicitudSeleccionada, 
  putEfectorLaboratorio, 
  setearValorEnPractica 
} from '../../../../actions/autorizaciones/Autorizaciones';
import { startAlerta } from '../../../../actions/ui/alertas';

export const EfectorLaboratorio = ({disabled}) => {
  const dispatch = useDispatch();

  const { practicas = [], solicitudSeleccionada = {} } = useSelector((state) => state.autorizaciones);

  const practica = practicas.find(s => s.idCodNom !== null);

  useEffect(() => {
    if (solicitudSeleccionada.idSolicitud) {
      dispatch(getPracticasSolicitudSeleccionada(solicitudSeleccionada.idSolicitud, false, null, true));
    }
  }, [solicitudSeleccionada.idSolicitud]);

  const verifyContacto = (name, value) => {
    if (name === "emailEfectorI") return validateEmail(value);
    else if (/\D/.test(value) || value.length !== 10) return true;
    else return false;
  };

  const validateEmail = (email) => {
    let reg = new RegExp(/^[^\s@]+@[^\s@]+\.[^\s@]+$/);
    if (reg.test(email) || email?.length === 0) {
      return false;
    } else {
      return true;
    }
  };

  const handleInputContactosEfectorIChange = ({ target }) => {
    dispatch(
      setearValorEnPractica(practica?.idCodNom, target.name, target.value)
    );
    dispatch(
      setearValorEnPractica(
        practica?.idCodNom,
        target.name === "emailEfectorI"
          ? "emailEfectorIError"
          : "celularEfectorIError",
        target.value ? verifyContacto(target.name, target.value) : false
      )
    );
  };

  const onSaveHandler = () => {
    if (!practica.idEfectorFacturacion) 
      return dispatch(
        startAlerta(
          `El Efector no puede quedar vacio.`,
          "error",
          "Error"
        )
      );    
      
    const data = {
      idSolicitud: solicitudSeleccionada.idSolicitud, 
      idEfectorFacturacion: practica.idEfectorFacturacion,
      idCartillaPrestador: practica.idCartillaPrestador,
      idPrestador: practica.idPrestador,
    }

    dispatch(
      putEfectorLaboratorio(
        data
      )
    );        
  };
console.log(practica);
  return (
    <>
      <AutorizacionesAccordionEfector
        idTipoEfector={
          AUTORIZACIONES_TIPO_EFECTOR.INSTITUCIONAL
        }
        practica={practica}
        disabled={disabled || solicitudSeleccionada?.idEstadoSolicitud ===
          AUTORIZACIONES_SOLICITUDES_ESTADOS.AUDITORIA_ADMINISTRATIVA
        }
        preEfector={
          !!practica.idCartillaPrestador
            ? practica.cartillaPrestadores?.atiendeCentroPropio
              ? {
                domicilio: practica.cartillaPrestadores.centroMedicoPropio.direccion,
                localidad: { descripcion_localidad: '' },
                provincia: { descripcion_provincia: '' },
                cartillaPrestadores: { prestador: { nombreApellido: practica.cartillaPrestadores.centroMedicoPropio.descripcionCentro } }
              }
              : practica.efectorInstitucional
                ? practica.efectorInstitucional
                : {
                  domicilio: 'SIN DOMICILIO',
                  localidad: { descripcion_localidad: '' },
                  provincia: { descripcion_provincia: '' },
                  cartillaPrestadores: { prestador: { nombreApellido: practica.cartillaPrestadores?.prestador?.nombreApellido } }
                }
            : null
        }
        desdeAuditar={true}
        emailEfectorI={practica.emailEfectorI}
        celularEfectorI={practica.celularEfectorI}
        emailEfectorIError={practica.emailEfectorIError}
        celularEfectorIError={practica.celularEfectorIError}
        setearEfector={(idEfector) => {
          dispatch(
            setearValorEnPractica(
              practica?.idCodNom,
              "idEfectorFacturacion",
              idEfector
            )
          );
        }}
        setearEfectorP={(idEfector) => {
          dispatch(
            setearValorEnPractica(
              practica?.idCodNom,
              "idCartillaPrestador",
              idEfector
            )
          );
        }}
        setearContactoEfectorI={handleInputContactosEfectorIChange}
        setearCopiarEfectorF={(value) => {
          dispatch(
            setearValorEnPractica(
              practica.idCodNom,
              "copiaEfectorInstitucional",
              value
            )
          );
        }}
        conInternacion={false}
        traerEfectores={getEfectorLaboratorio}
        estaCorrecto={true}
        esDenunciaInternacion={false}
      />
      <div style={{ textAlign: "center", marginTop: "2.5rem" }}>
        <div style={{ display: 'inline-grid' }}>
          <Button
            onClick={onSaveHandler}
            // disabled={props.disabled && !permiteAgregarPracticaPeriodo}
            variant="contained"
            color="primary"
          >
            Guardar Cambios
          </Button>
        </div>
      </div>
    </>
  )
}
